<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <lazy-div :load="doInit">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="query"></v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
          <v-toolbar-title v-if="query"
            >Miscellaneous Global Parameters
            <v-btn text color="primary" @click="queryModeSwitch" v-if="query">
              Edit
              <v-icon right>mdi-pencil</v-icon>
            </v-btn>
          </v-toolbar-title>
          <v-toolbar-title v-else>Miscellaneous Global Parameters </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-flex xs12 class="mt-1">
            <message :messages="messages"></message>
          </v-flex>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <div class="subheading font-weight-strong teal--text">Underwriting</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  :label="labels.startUwyr"
                  v-model="miscForm.startUwyr"
                  :error-messages="errors.collect('startUwyr')"
                  data-vv-name="startUwyr"
                  :data-vv-as="labels.startUwyr"
                  v-validate="'numeric|max:4'"
                  :disabled="query"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="deptList"
                  item-text="label"
                  item-value="value"
                  :label="labels.mtrDept"
                  v-model="miscForm.mtrDept"
                  :error-messages="errors.collect('mtrDept')"
                  data-vv-name="mtrDept"
                  :data-vv-as="labels.mtrDept"
                  v-validate="'required'"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :label="labels.maxDayDelPol"
                  v-model="miscForm.maxDayDelPol"
                  :error-messages="errors.collect('maxDayDelPol')"
                  data-vv-name="maxDayDelPol"
                  :data-vv-as="labels.maxDayDelPol"
                  v-validate="'numeric|max:18'"
                  :disabled="query"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="clienTypes"
                  item-text="label"
                  item-value="value"
                  :label="labels.defInsClientType"
                  v-model="miscForm.defInsClientType"
                  :error-messages="errors.collect('defInsClientType')"
                  data-vv-name="defInsClientType"
                  :data-vv-as="labels.defInsClientType"
                  v-validate="'required'"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.add1uwYr"
                  v-model="miscForm.add1uwYr"
                  :error-messages="errors.collect('add1uwYr')"
                  data-vv-name="add1uwYr"
                  :data-vv-as="labels.add1uwYr"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.renewalInforApplicable"
                  v-model="miscForm.renewalInforApplicable"
                  :error-messages="errors.collect('renewalInforApplicable')"
                  data-vv-name="renewalInforApplicable"
                  :data-vv-as="labels.renewalInforApplicable"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :items="defReducingBal"
                  v-model="miscForm.defRedBal1"
                  item-text="label"
                  item-value="value"
                  :label="labels.defRedBal1"
                  :error-messages="errors.collect('defRedBal1')"
                  data-vv-name="defRedBal1"
                  :data-vv-as="labels.defRedBal1"
                  :disabled="query"
                ></v-autocomplete>
                <!-- <v-checkbox :label="labels.defRedBal1" v-model="miscForm.defRedBal1" :error-messages="errors.collect('defRedBal1')"
                data-vv-name="defRedBal1" :data-vv-as="labels.defRedBal1" :disabled="query"></v-checkbox> -->
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="defReducingBal"
                  v-model="miscForm.defRedBal2"
                  item-text="label"
                  item-value="value"
                  :label="labels.defRedBal2"
                  :error-messages="errors.collect('defRedBal2')"
                  data-vv-name="defRedBal2"
                  :data-vv-as="labels.defRedBal2"
                  :disabled="query"
                ></v-autocomplete>
                <!-- <v-checkbox :label="labels.defRedBal2" v-model="miscForm.defRedBal2" :error-messages="errors.collect('defRedBal2')"
                data-vv-name="defRedBal2" :data-vv-as="labels.defRedBal2" :disabled="query"></v-checkbox> -->
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :items="defReducingBal"
                  v-model="miscForm.defRedBal3"
                  item-text="label"
                  item-value="value"
                  :label="labels.defRedBal3"
                  :error-messages="errors.collect('defRedBal3')"
                  data-vv-name="defRedBal3"
                  :data-vv-as="labels.defRedBal3"
                  :disabled="query"
                ></v-autocomplete>
                <!-- <v-checkbox :label="labels.defRedBal3" v-model="miscForm.defRedBal3" :error-messages="errors.collect('defRedBal3')"
                data-vv-name="defRedBal3" :data-vv-as="labels.defRedBal3" :disabled="query"></v-checkbox> -->
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.cvrPeriodExclMaintPer"
                  v-model="miscForm.cvrPeriodExclMaintPer"
                  :error-messages="errors.collect('cvrPeriodExclMaintPer')"
                  data-vv-name="cvrPeriodExclMaintPer"
                  :data-vv-as="labels.cvrPeriodExclMaintPer"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.valscheme"
                  v-model="miscForm.valscheme"
                  :error-messages="errors.collect('valscheme')"
                  data-vv-name="valscheme"
                  :data-vv-as="labels.valscheme"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.valVehReg"
                  v-model="miscForm.valVehReg"
                  :error-messages="errors.collect('valVehReg')"
                  data-vv-name="valVehReg"
                  :data-vv-as="labels.valVehReg"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex xs12>
                <div class="subheading font-weight-strong teal--text">Reinsurance</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.riDisc"
                  v-model="miscForm.riDisc"
                  :error-messages="errors.collect('riDisc')"
                  data-vv-name="riDisc"
                  :data-vv-as="labels.riDisc"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.brkCedRimand"
                  v-model="miscForm.brkCedRimand"
                  :error-messages="errors.collect('brkCedRimand')"
                  data-vv-name="brkCedRimand"
                  :data-vv-as="labels.brkCedRimand"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.altInsuffRi"
                  v-model="miscForm.altInsuffRi"
                  :error-messages="errors.collect('altInsuffRi')"
                  data-vv-name="altInsuffRi"
                  :data-vv-as="labels.altInsuffRi"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.insdAddrMandRi"
                  v-model="miscForm.insdAddrMandRi"
                  :error-messages="errors.collect('insdAddrMandRi')"
                  data-vv-name="insdAddrMandRi"
                  :data-vv-as="labels.insdAddrMandRi"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <cal-picker
                  v-model="miscForm.impXoldate"
                  :label="labels.impXoldate"
                  :error-messages="errors.collect('impXoldate')"
                  data-vv-name="impXoldate"
                  :data-vv-as="labels.impXoldate"
                  :disabled="query"
                />
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="insNameSOARef"
                  v-model="miscForm.insuredNameOnSOARef"
                  item-text="label"
                  item-value="value"
                  :label="labels.insuredNameOnSOARef"
                  :error-messages="errors.collect('insuredNameOnSOARef')"
                  data-vv-name="miscForm.insuredNameOnSOARef"
                  :data-vv-as="labels.insuredNameOnSOARef"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex xs12>
                <div class="subheading font-weight-strong teal--text">Print Settings</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.prtLogo"
                  v-model="miscForm.prtLogo"
                  :error-messages="errors.collect('prtLogo')"
                  data-vv-name="prtLogo"
                  :data-vv-as="labels.prtLogo"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.prtSysDateTime"
                  v-model="miscForm.prtSysDateTime"
                  :error-messages="errors.collect('prtSysDateTime')"
                  data-vv-name="prtSysDateTime"
                  :data-vv-as="labels.prtSysDateTime"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.prtRiskSIAbbrev"
                  v-model="miscForm.prtRiskSIAbbrev"
                  :error-messages="errors.collect('prtRiskSIAbbrev')"
                  data-vv-name="prtRiskSIAbbrev"
                  :data-vv-as="labels.prtRiskSIAbbrev"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.prtDigitSign"
                  v-model="miscForm.prtDigitSign"
                  :error-messages="errors.collect('prtDigitSign')"
                  data-vv-name="prtDigitSign"
                  :data-vv-as="labels.prtDigitSign"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex xs12>
                <div class="subheading font-weight-strong teal--text">Sanction</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="miscForm.mchNameThUpp"
                  :label="labels.mchNameThUpp"
                  :error-messages="errors.collect('mchNameThUpp')"
                  data-vv-name="mchNameThUpp"
                  :data-vv-as="labels.mchNameThUpp"
                  v-num-mask="{ negative: false, intScale: 2, decScale: 2 }"
                  :disabled="query"
                  v-validate="valMchNameThUpp"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="miscForm.mchNameThLwr"
                  :label="labels.mchNameThLwr"
                  :error-messages="errors.collect('mchNameThLwr')"
                  data-vv-name="mchNameThLwr"
                  :data-vv-as="labels.mchNameThLwr"
                  v-num-mask="{ negative: false, intScale: 2, decScale: 2 }"
                  :disabled="query"
                  v-validate="valMchNameThLwr"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex xs12>
                <div class="subheading font-weight-strong teal--text">Risk Accumulation</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="miscForm.holdCvr"
                  :label="labels.holdCvr"
                  :error-messages="errors.collect('holdCvr')"
                  data-vv-name="holdCvr"
                  :data-vv-as="labels.holdCvr"
                  v-validate="'required|numeric'"
                  :disabled="query"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="miscForm.notCom"
                  :label="labels.notCom"
                  :error-messages="errors.collect('notCom')"
                  data-vv-name="notCom"
                  :data-vv-as="labels.notCom"
                  v-validate="'required|numeric'"
                  :disabled="query"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-divider class="pt-3"></v-divider>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ miscForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDate(miscForm.createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ miscForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDate(miscForm.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions v-if="!query">
          <v-btn color="error" @click="queryModeSwitch"> Cancel<v-icon right dark>mdi-cancel</v-icon> </v-btn>
          <v-btn color="primary" @click="doSave" :loading="submitting"> Save Parameters<v-icon right>mdi-content-save</v-icon> </v-btn>
        </v-card-actions>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
import clone from 'clone'
import { formatPrice } from '@/utils/index'
import CalPicker from '../../reusable/global/CalPicker.vue'
export default {
  data() {
    return {
      labels: {
        startUwyr: 'Start Month / Day of UW Year',
        mtrDept: 'Department Code for Motor',
        maxDayDelPol: 'Max.Days to Delete Policy',
        defInsClientType: 'Default Insured Client Type',
        renewalInforApplicable: 'Renewal Information Application',
        insuredNameOnSOARef: 'Insured Name on SOA Reference',
        add1uwYr: 'Add 1 to Underwriting Year',
        defRedBal1: 'Default Reducing Balance 1',
        defRedBal2: 'Default Reducing Balance 2',
        defRedBal3: 'Default Reducing Balance 3',
        cvrPeriodExclMaintPer: 'Cover Period Exclude Maintenance Period',
        valscheme: 'Validate Scheme For Agent',
        valVehReg: 'Validate Vehicle Registration > 8 Characters',
        riDisc: 'Include RI Discount in Premium',
        brkCedRimand: 'Enter Broker & Reinsurer',
        altInsuffRi: 'Alert if Insufficient RI',
        insdAddrMandRi: 'Insured Address Mandatory',
        impXoldate: 'Date XOL Implemented',
        prtLogo: 'Print Logo',
        prtSysDateTime: 'Print System Date / Time on Document',
        prtRiskSIAbbrev: 'Print Risk SI Abbreviated Schedule',
        prtDigitSign: 'Print Digital Signature Document',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        mchNameThUpp: 'Matched Name Threshold (Upper limit)',
        mchNameThLwr: 'Matched Name Threshold (Lower limit)',
        holdCvr: 'Days Hold Cover',
        notCom: 'Days Not Commence'
      },
      miscForm: {
        startUwyr: null,
        mtrDept: null,
        maxDayDelPol: null,
        defInsClientType: null,
        renewalInforApplicable: null,
        insuredNameOnSOARef: false,
        add1uwYr: false,
        defRedBal1: false,
        defRedBal2: false,
        defRedBal3: false,
        cvrPeriodExclMaintPer: false,
        valscheme: false,
        valVehReg: false,
        riDisc: false,
        brkCedRimand: false,
        altInsuffRi: false,
        insdAddrMandRi: false,
        impXoldate: undefined,
        prtLogo: false,
        prtSysDateTime: false,
        prtRiskSIAbbrev: false,
        prtDigitSign: false,
        createdDate: '',
        createdBy: '',
        modifiedBy: this.$store.state.token.firstName,
        modifiedDate: new Date(),
        mchNameThUpp: formatPrice(0),
        mchNameThLwr: formatPrice(0),
        holdCvr: null,
        notCom: null
      },
      tempFormStorage: [],
      tempDeptListStorage: [],
      sideFunction: [
        {
          text: 'Miscellaneous Accounts Parameters',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'miscAcct' }
        },
        {
          text: 'Miscellaneous Claims Parameters',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'miscClm' }
        },
        {
          text: 'Miscellaneous Treaty Parameters',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'miscTty' }
        }
      ],
      deptList: [],
      submitting: false,
      query: true,
      clienTypes: [],
      insNameSOARef: [
        { label: 'Last', value: '0' },
        { label: 'First', value: '1' }
      ],
      defReducingBal: [
        { label: 'Gross', value: true },
        { label: 'Net', value: false }
      ],
      sanctionCount: 0
    }
  },
  methods: {
    async doInit() {
      const apiURI = this.menu.getMiscGlobalParam
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.miscForm.startUwyr = this.padString(data.miscParam.startUwyr)
            this.miscForm.mtrDept = data.miscParam.mtrDept
            this.miscForm.add1uwYr = data.miscParam.add1uwYr
            this.miscForm.defRedBal1 = data.miscParam.defRedBal1
            this.miscForm.defRedBal2 = data.miscParam.defRedBal2
            this.miscForm.defRedBal3 = data.miscParam.defRedBal3
            this.miscForm.cvrPeriodExclMaintPer = data.miscParam.cvrPeriodExclMaintPer
            this.miscForm.valscheme = data.miscParam.valscheme
            this.miscForm.valVehReg = data.miscParam.valVehReg
            this.miscForm.riDisc = data.miscParam.riDisc
            this.miscForm.brkCedRimand = data.miscParam.brkCedRimand
            this.miscForm.altInsuffRi = data.miscParam.altInsuffRi
            this.miscForm.insdAddrMandRi = data.miscParam.insdAddrMandRi
            this.miscForm.impXoldate = data.miscParam.impXoldate
            this.miscForm.prtLogo = data.miscParam.prtLogo
            this.miscForm.prtSysDateTime = data.miscParam.prtSysDateTime
            this.miscForm.prtRiskSIAbbrev = data.miscParam.prtRiskSIAbbrev
            this.miscForm.prtDigitSign = data.miscParam.prtDigitSign
            this.miscForm.createdBy = data.createdBy
            this.miscForm.createdDate = data.createdDate
            this.miscForm.modifiedBy = data.modifiedBy
            this.miscForm.modifiedDate = data.modifiedDate
            this.deptList = data.deptList
            this.clienTypes = data.clientTypesList
            this.miscForm.maxDayDelPol = data.miscParam.maxDayDelPol
            this.miscForm.renewalInforApplicable = data.miscParam.renewalInforApplicable
            this.miscForm.defInsClientType = data.miscParam.defInsClientType
            if (data.miscParam.insuredNameOnSOARef === true) {
              this.miscForm.insuredNameOnSOARef = '1'
            } else {
              this.miscForm.insuredNameOnSOARef = '0'
            }
            this.miscForm.mchNameThUpp = formatPrice(data.miscParam.mchNameThUpp)
            this.miscForm.mchNameThLwr = formatPrice(data.miscParam.mchNameThLwr)
            this.sanctionCount = data.sanctionCount
            this.miscForm.holdCvr = data.miscParam.holdCvr
            this.miscForm.notCom = data.miscParam.notCom
          }
          this.tempFormStorage = clone(this.miscForm)
          this.tempDeptListStorage = clone(this.deptList)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.deptList = data.data.deptList
          }
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitting = true
          const apiURI = this.menu.saveMiscGlobalParam
          if (apiURI) {
            if (this.miscForm.insuredNameOnSOARef === '1') {
              this.miscForm.insuredNameOnSOARef = true
            } else {
              this.miscForm.insuredNameOnSOARef = false
            }
            this.$http
              .post(apiURI, this.miscForm)
              .then((result) => {
                const { data } = result
                if (data) {
                  this.notify(data)
                  this.doInit()
                }
                this.submitting = false
              })
              .catch((err) => {
                this.submitting = false
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    formatDate(xDate) {
      return formatDisplayDate(xDate)
    },
    padString(value) {
      if (value) {
        return value.toString().padStart(4, '0')
      } else {
        return value
      }
    },
    async queryModeSwitch() {
      this.errors.clear()
      if (this.query === false) {
        this.toggleToTempStorage()
        this.query = true
      } else {
        this.query = false
      }
    },
    async toggleToTempStorage() {
      this.miscForm = this.tempFormStorage
      this.deptList = this.tempDeptListStorage
      this.doInit()
    }
  },
  computed: {
    menu() {
      return this.$store.state.miscParams.menu
    },
    valMchNameThUpp() {
      if (this.sanctionCount > 0) {
        if (this.miscForm.mchNameThUpp <= this.miscForm.mchNameThLwr) {
          return 'sanction:' + 'Matched Named Threshold (Upper limit) cannot be less than or equal to the lower limit'
        } else {
          return 'not_zero'
        }
      } else {
        return ''
      }
    },
    valMchNameThLwr() {
      if (this.sanctionCount > 0) {
        if (this.miscForm.mchNameThLwr > this.miscForm.mchNameThUpp) {
          return 'sanction:' + 'Matched Named Threshold (Lower limit) cannot be greater than or equal to the lower limit'
        } else {
          return 'not_zero'
        }
      } else {
        return ''
      }
    }
  },
  components: {
    SideFunctionMenu
  },
  mixins: [MessageMixin, CalPicker]
}
</script>

<style>
</style>
